export default function PageHeader({ title, subtitle = '', action }) {
    return (
        <div className="w-full">
            <div className="flex justify-between items-start">
                <div>
                    <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-zinc-900 dark:text-zinc-100">
                        {title}
                    </h2>
                    {subtitle && (
                        <p className="mt-1 text-sm text-zinc-500 dark:text-zinc-400">{subtitle}</p>
                    )}
                </div>
                {action && <div>{action}</div>}
            </div>
        </div>
    );
}
